import React from "react";
import DateToday from "./DateToday";
import arrowWhite from "../images/arrow-white.png";
import { Link } from "react-router-dom";

export default function TopTitleBannerMobileWithArrow(props) {
  return (
    <div className="main-top-title-banner-container">
      <div className="date-container-mobile">
        <DateToday />
      </div>
      <div className="title-text-banner-mobile-arrow">
        <Link to="/">
          <img alt=""
            style={{ width: 15, marginRight: 24, marginTop: 7 }}
            src={arrowWhite}
          />
        </Link>
        {props.title}
      </div>
    </div>
  );
}
